<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="修改采购" />
		<PurForm :purForm="form" />
	</div>
</template>

<script>
	import PurForm from '@/components/Purchase/Form'
	export default {
		data() {
			return {
				form: {}
			}
		},
		created() {
			this.$axios.post('Myseller-setting-getCinfo', {
				id: this.$route.query.id
			}).then(data => {
				data.num *= 1;
				this.form = data;
			})
		},
		components: {
			PurForm
		}
	}
</script>

<style>
</style>
